import axios from 'axios';
import {config} from '../config'

export default axios.create({
    baseURL: config.chatapiurl,
});

export const chatAxiosPrivate = axios.create({
    baseURL: config.chatapiurl,
    headers: { 'Content-Type': 'application/json' },
    // withCredentials: true
});